import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Marketing = (props) => (
  <PermissionMatrix {...props} areaLabel="Marketing" hierarchy={['Diretor', 'Gerente', 'Analista']} />
);

export default Marketing;
